import React, { useState } from "react";
import { Photo, Container, ViewLogin } from "./styles";
import logo from "./../../../images/logo.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks/AuthContext";
import { Button, Input, Modal } from "antd";
import api from "../../../services/api";
import { toast } from "react-toastify";

export default function Login({ credential }) {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailReset, setEmailReset] = useState("");
  const [visibleModal, setVisibleModal] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState("");

  const { signIn } = useAuth();

  async function loginCredential() {
    await api
      .post("credential-session", { email, password })
      .then((response) => {
        const { credential, token } = response.data;

        localStorage.setItem("@guruseg-credential:token", token);
        localStorage.setItem("@guruseg-credential:id", credential.id);

        api.defaults.headers = {
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
        };

        navigate("/credential");
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function sendEmailReset() {
    setIsLoadingModal(true);
    if (email) {
      await api
        .post("/password-forgot", {
          email: emailReset.toLowerCase().replace(/ /g, ""),
        })
        .then(async (response) => {
          toast.success(
            "Email para concluir a recuperação de senha foi enviado com sucesso.",
          );
          setVisibleModal(false);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.warn("Ocorreu um erro interno");
              }
            } else {
              toast.warn("Ocorreu um erro interno");
            }
          } else {
            toast.warn("Ocorreu um erro interno");
          }
        });
    } else {
      toast.warn("Preencha o email para recuperar sua senha");
    }
    setIsLoadingModal(false);
  }

  return (
    <Container>
      <ViewLogin>
        <Photo src={logo} />
        <Input
          placeholder="email"
          value={email}
          type="email"
          onChange={(text) => {
            setEmail(text.target.value);
          }}
        />
        <Input
          placeholder="senha"
          value={password}
          type="password"
          onChange={(text) => {
            setPassword(text.target.value);
          }}
        />
        <Button
          type="primary"
          loading={isLoading}
          onClick={async () => {
            setIsLoading(true);
            if (credential) {
              await loginCredential();
            } else {
              await signIn({
                email: email.toLowerCase().replace(/ /g, ""),
                password,
              });
            }
            setIsLoading(false);
          }}
        >
          Fazer Login
        </Button>
        <Button
          color="default"
          variant="text"
          onClick={async () => {
            setEmailReset(email);
            setVisibleModal(true);
          }}
        >
          Esqueci minha senha
        </Button>
      </ViewLogin>
      <Modal
        title="Email de Recuperação"
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={"ENVIAR EMAIL"}
        cancelText="FECHAR"
        onOk={() => {
          sendEmailReset();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <p>Digite seu email</p>
        <Input
          style={{ marginTop: 2, marginBottom: 25 }}
          placeholder="email"
          value={emailReset}
          type="email"
          onChange={(text) => {
            setEmailReset(text.target.value);
          }}
        />
      </Modal>
    </Container>
  );
}
